import React from 'react';
import './CareerCard.css';

const CareerCard = () => {
  return (
    <div className="career-wrapper">
      <h2 className="career-title">Redefine Your Career Path</h2>
      <p className="career-subtitle">
        Discover how our students transformed their journeys with this course — unlocking new opportunities and evolving into successful professionals in the digital space.
      </p>

      <div className="career-container">
        {/* Card 1 */}
        <div className="career-card">
          <img src="/img1.jpg" alt="Aditya Shinkar" className="career-card__image" />
          <h3 className="career-card__name">Aditya Shinkar</h3>

          <div className="career-card__timeline">
            <span className="career-card__label">Before Arrow Digital</span>
            <div className="career-card__progress">
              <div className="career-card__dot"></div>
              <div className="career-card__line"></div>
              <div className="career-card__dot active"></div>
            </div>
            <span className="career-card__label active">After Arrow Digital</span>
          </div>

          <div className="career-card__job-boxes">
            <div className="career-card__job-box">
              <p className="career-card__role1">Sales & Distribution Head</p>
              <p className="career-card__company1">STRUGENCE</p>
            </div>
            <div className="career-card__job-box">
              <p className="career-card__role">Media Planner</p>
              <p className="career-card__company">MADISON WORLD</p>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="career-card">
          <img src="/img3.jpg" alt="Arvindh S" className="career-card__image" />
          <h3 className="career-card__name">Arvindh S</h3>

          <div className="career-card__timeline">
            <span className="career-card__label">Before Arrow Digital</span>
            <div className="career-card__progress">
              <div className="career-card__dot"></div>
              <div className="career-card__line"></div>
              <div className="career-card__dot active"></div>
            </div>
            <span className="career-card__label active">After Arrow Digital</span>
          </div>

          <div className="career-card__job-boxes">
            <div className="career-card__job-box">
              <p className="career-card__role1">Sr. Executive Digital Marketing</p>
              <p className="career-card__company1">POORVIKA</p>
            </div>
            <div className="career-card__job-box">
              <p className="career-card__role">Executive - Paid Social</p>
              <p className="career-card__company">groupM</p>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="career-card">
          <img src="/img2.jpg" alt="Krishna Singh" className="career-card__image" />
          <h3 className="career-card__name">Krishna Singh</h3>

          <div className="career-card__timeline">
            <span className="career-card__label">Before Arrow Digital</span>
            <div className="career-card__progress">
              <div className="career-card__dot"></div>
              <div className="career-card__line"></div>
              <div className="career-card__dot active"></div>
            </div>
            <span className="career-card__label active">After Arrow Digital</span>
          </div>

          <div className="career-card__job-boxes">
            <div className="career-card__job-box">
              <p className="career-card__role1">Lead Management System</p>
              <p className="career-card__company1">PORTER</p>
            </div>
            <div className="career-card__job-box">
              <p className="career-card__role">Analyst - Commerce</p>
              <p className="career-card__company">Performics</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerCard;
